import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { FeaturesService } from '../features.service';
import { Features } from '../features';
import { FeaturesComponent } from '../feature/features.component';
import { FeatureAdminContainerComponent } from '@app/_components/property/feature/feature-admin-container/feature-admin-container.component';
import { PropertyFeatureTemplateDetailComponent } from '@app/_components/property/property-feature-template/property-feature-template-detail/property-feature-template-detail.component';

@Component({
    selector: 'app-feature-listing',
    templateUrl: './feature-listing.component.html',
    styleUrls: ['./feature-listing.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class FeaturesListComponent implements OnInit {
	constructor(
		private featureService: FeaturesService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = featureService.statuses
	}



	// data
	features: any;
	feature: Features;
	featuresObjList: any[] = [];
	propertyFeaturesList: any[] = [];

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'featureId', header: 'Id', width: 'auto' },
		{ field: 'featureName', header: 'Feature Name', width: 'auto' },
		/*{ field: 'shortTermRentalId', header: 'STRId', width: 'auto' },
		{ field: 'propertyCode', header: 'Property Code', width: 'auto' },*/
		{ field: 'title', header: 'Title', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'type', header: 'Type', width: 'auto' },
		{ field: 'value', header: 'Value', width: 'auto' },
		{ field: 'quantity', header: 'Quantity', width: 'auto' },
		{ field: 'featureType', header: 'Feature Type', width: 'auto' },
		{ field: 'featureLabel', header: 'Feature Label', width: 'auto' },
		{ field: 'defaultFeature', header: 'Default Feature', width: 'auto' },
		{ field: 'defaultHighlight', header: 'Default Highlight', width: 'auto' },
		{ field: 'describesType', header: 'Des Type', width: 'auto' },
		{ field: 'privateNotes', header: 'Private Notes', width: 'auto' },
		{ field: 'distance', header: 'Distance', width: 'auto' },
		{ field: 'distanceUnit', header: 'Distance Unit', width: 'auto' },
		{ field: 'kbmMap', header: 'KBM Map', width: 'auto' },
		{ field: 'vrboMap', header: 'VRBO Map', width: 'auto' },
		{ field: 'rentalsUnitedMap', header: 'Rentals United Map', width: 'auto' },
		{ field: 'airbnbCode', header: 'Airbnb Code', width: 'auto' },
		{ field: 'bookingcomCode', header: 'Bookingcom Code', width: 'auto' },
		{ field: 'expediaCode', header: 'Expedia Code', width: 'auto' },
		{ field: 'googleCode', header: 'Google Code', width: 'auto' },
		{ field: 'marriottCode', header: 'Marriott Code', width: 'auto' },
		{ field: 'vrboCode', header: 'Vrbo Code', width: 'auto' },
	];

	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'description': [
			{ type: 'required', message: 'Required' }
		],
	}

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.featureId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


/*********
		* Copy To Feature
		*
		*/
	copyToFeature() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			feature: this.feature,
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FeatureAdminContainerComponent, dialogConfig);
	}




	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-feature-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.featureService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.features;
						this.recordTotal = res.page.recordTotal;
						this.features = res.data.features;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.features = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(feature: Features) {
		try {
			this.formLoading = true;
			this.featureService.update(feature)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.features.map((feature, i) => {
							if (feature.featureId === res.data.feature.featureId) {
								this.features[i] = res.data.feature;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(feature: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(feature));

			this.formLoading = true;
			this.featureService.delete(feature.featureId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.features.splice(this.features.indexOf(feature), 1);
						this.recordTotal = this.features.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Feature ' + feature.featureId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Feature ' + feature.featureId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Feature'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FeaturesComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addFeatureCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(feature: Features) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			feature: feature,
			title: 'Edit Feature'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FeaturesComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateFeatureCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteFeatureCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addFeatureCB(feature: Features) {
		console.log('Adding Feature: ' + JSON.stringify(feature));
		// if we don't have a features array yet...
		if (!this.features) {
			this.features = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.features.unshift(feature);

		// no idea what this is but it is required to update the array
		this.features = [...this.features];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Feature ' + feature.featureId + ' Added', life: 3000 });
	}

	updateFeatureCB(feature: Features) {
		console.log('Updating Feature: ' + JSON.stringify(feature));
		let itemIndex = this.features.findIndex((item: any) => item.featureId === feature.featureId);
		this.features[itemIndex] = feature;

		// no idea what this is but it is required to update the array
		this.features = [...this.features];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Feature ' + feature.featureId + ' Updated', life: 3000 });
	}

	deleteFeatureCB(feature: Features) {
		console.log('Removing Feature: ' + feature);
		this.features.splice(this.features.indexOf(feature), 1);
		this.recordTotal = this.features.length;

		// no idea what this is but it is required to update the array
		this.features = [...this.features];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Feature ' + feature.featureId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.features ? this.first === (this.features.length - this.rows) : true; }
	isFirstPage(): boolean { return this.features ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(feature: any) {
		if (feature?.status) {
			const status = this.statuses.find((e: any) => e.value == feature.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	addIntoCheckedList(propertyFeature: any){
		console.log("FeaturesListtttttttt : "+JSON.stringify(propertyFeature));
		var count = 0;
		for (let i = 0; i < this.featuresObjList.length; i++) {
		  if (this.featuresObjList[i].featureId == propertyFeature.featureId) {
			this.featuresObjList.splice(this.featuresObjList.indexOf(this.featuresObjList[i]), 1);
			count = 1;
			}
		}
		if (count == 0) {
			this.featuresObjList.push(propertyFeature);
		}
		console.log("FeaturesList : "+JSON.stringify(this.featuresObjList));
	}
	
	/*********
		 * Add To PropertyFeatureTemplate
		 *
		 */
	addToPropertyFeatureTemplate() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'List of Property Feature Template',
			propertyFeatures: this.propertyFeaturesList
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyFeatureTemplateDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				dialogRef.close();
			});
	}
}
